var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4996 9.49536C33.19 9.31779 32.8091 9.31932 32.5011 9.49955L22.6445 15.2636V10.3594C22.6445 10.0025 22.4536 9.67293 22.1441 9.49536C21.8345 9.31779 21.4537 9.31932 21.1456 9.49955L11.2891 15.2636V0.996094C11.2891 0.445984 10.8431 0 10.293 0H0.996094C0.445984 0 0 0.445984 0 0.996094V33.0039C0 33.554 0.445984 34 0.996094 34H33.0039C33.554 34 34 33.554 34 33.0039V10.3594C34 10.0025 33.8091 9.67293 33.4996 9.49536ZM1.99219 1.99219H9.29688V3.32031H1.99219V1.99219ZM32.0078 32.0078H1.99219V5.3125H9.29688V17C9.29688 17.7687 10.1332 18.2473 10.7958 17.8598L20.6523 12.0958V17C20.6523 17.7687 21.4887 18.2473 22.1513 17.8598L32.0078 12.0958V32.0078Z",
    fill: "#1C4C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2773 22.0137H10.293C9.74286 22.0137 9.29688 22.4597 9.29688 23.0098V26.9941C9.29688 27.5443 9.74286 27.9902 10.293 27.9902H14.2773C14.8275 27.9902 15.2734 27.5443 15.2734 26.9941V23.0098C15.2734 22.4597 14.8275 22.0137 14.2773 22.0137ZM13.2812 25.998H11.2891V24.0059H13.2812V25.998Z",
    fill: "#1C4C5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 22.0137H21.6484C21.0983 22.0137 20.6523 22.4597 20.6523 23.0098V26.9941C20.6523 27.5443 21.0983 27.9902 21.6484 27.9902H25.6328C26.1829 27.9902 26.6289 27.5443 26.6289 26.9941V23.0098C26.6289 22.4597 26.1829 22.0137 25.6328 22.0137ZM24.6367 25.998H22.6445V24.0059H24.6367V25.998Z",
    fill: "#1C4C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForCompanies);
export default __webpack_public_path__ + "static/media/for_companies.dc5ffe85.svg";
export { ForwardRef as ReactComponent };